import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';
import { RepoService } from '../services/repo.service';
import { ToastService } from '../services/toast.service';

/**
 * Gate /sap behind the sas2r session and a selected repo — the same contract as
 * `sdtmAccessGuard`, so the two products behave identically from the profile menu.
 */
export const sapAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(OauthService);
  const repoService = inject(RepoService);
  const toastService = inject(ToastService);

  const user = await auth.getUser();
  if (!user) {
    router.navigate(['/']);
    return false;
  }

  if (!repoService.repo()) {
    console.log('Access to SAP denied: No repository selected');
    toastService.showError('Please connect the repository to access SAP');
    router.navigate(['/']);
    return false;
  }
  return true;
};
